import NotificationCenter from './notification-center.vue'

export default {
  'notification-center': NotificationCenter
}
